// useCatalogueStatus.ts
import * as signalR from "@microsoft/signalr";
import { useEffect, useRef, useState } from "react";
import { API_URL } from "../_config/config.const";
import { accountService } from "../_services/accounts.service";

const API_NAME = "catalogueItemBid";

export function useCatalogueBid(catalogueId: number | null) {

    const [bids, setBids] = useState<Array<any> | null>(null);

    const [connected, setConnected] = useState(false);
    const connRef = useRef<signalR.HubConnection | null>(null);

    useEffect(() => {
        if (!catalogueId) {
            setBids(null);
            setConnected(false);
            return;
        }

        const currentUser = accountService.currentUserValue;

        const conn = new signalR.HubConnectionBuilder()
            .withUrl(`${API_URL}/hubs/${API_NAME}`, {
                accessTokenFactory: () => currentUser.token
            })
            .withAutomaticReconnect([0, 1000, 2000, 5000, 10000])
            .build();

        connRef.current = conn;

        conn.on("BidsUpdated", (payload: { items: Array<any>; updatedAt: number }) => {
            setBids(payload?.items ?? []);
        });

        conn.onreconnecting(() => {
            setConnected(false);
        });

        conn.onreconnected(async () => {
            setConnected(true);
            try {
                await conn.invoke("JoinCatalogue", catalogueId);
            } catch (err) {
                console.error("SignalR rejoin failed", err);
            }
        });

        conn.onclose(() => {
            setConnected(false);
        });

        (async () => {
            try {
                await conn.start();
                setConnected(true);
                await conn.invoke("JoinCatalogue", catalogueId);
            } catch (err) {
                console.error("SignalR connect failed", err);
            }
        })();

        return () => {
            (async () => {
                try {
                    if (conn.state === signalR.HubConnectionState.Connected) {
                        await conn.invoke("LeaveCatalogue", catalogueId);
                    }
                } finally {
                    await conn.stop();
                    setConnected(false);
                }
            })();
        };
    }, [catalogueId]);

    return { bids, connected };
}